import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { enUS } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';

type Props = {
	startDate?: Date | null;
	endDate?: Date | null;
	onRangeChange?: (start: Date | null, end: Date | null) => void;
};

const MonthRangePicker: React.FC<Props> = (props) => {


	
	const [startDate, setStartDate] = useState<Date | null>(props.startDate || null);
	const [endDate, setEndDate] = useState<Date | null>(props.endDate || null);
  
	React.useEffect(() => {
		setStartDate(props.startDate|| null);
		setEndDate(props.endDate|| null);
	}, [props.startDate, props.endDate]);

	const handleStartChange = (date: Date | null) => {
		setStartDate(date);
		if (endDate && date && endDate < date) {
			setEndDate(null);
			props.onRangeChange?.(date, null);
		} else {
			props.onRangeChange?.(date, endDate);
		}
	};

	const handleEndChange = (date: Date | null) => {
		if (startDate && date && date < startDate) {
			alert('End date must be after start date.');
			return;
		}
		setEndDate(date);
		props.onRangeChange?.(startDate, date);
	};

	return (
		<div className="d-flex gap-2 align-items-end MonthRangePicker">
			<div>
				<label className="font-size-14 line-height-24 relative mb-0">Start Month</label>
				<DatePicker
					selected={startDate}
					onChange={handleStartChange}
					dateFormat="MM/yyyy"
					showMonthYearPicker
					className="form-control"
					placeholderText="Select"
					locale={enUS}
				/>
			</div>

			<div>
				<label className="font-size-14 line-height-24 relative mb-0">End Month</label>
				<DatePicker
					selected={endDate}
					onChange={handleEndChange}
					dateFormat="MM/yyyy"
					showMonthYearPicker
					className="form-control "
					placeholderText="Select"
					minDate={startDate ?? undefined}
					locale={enUS}
				/>
			</div>
		</div>
	);
};

export default MonthRangePicker;
